// extracted by mini-css-extract-plugin
export default {"createTaskContainer":"App_createTaskContainer__zM766","pageContainer":"App_pageContainer__H23-Q"};